import React, {useRef, useState} from 'react';
import Layout from "@/Shared/Layout";
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import AddedCouponsSearchFilter from "@/Pages/Coupons/Assets/AddedCouponsSearchFilter";
import PaginateCount from "@/Shared/PaginateCount";
import Pagination from "@/Shared/Pagination";
import TableHeadSort from "@/Shared/TableHeadSort";
import dayjs from "dayjs";
import AddedCouponActionBtns from "@/Pages/Coupons/Assets/AddedCouponActionBtns";
import AddedCouponBottomPanel from "@/Pages/Coupons/Assets/AddedCouponBottomPanel";
import useCheckbox from "@/Hooks/useCheckbox";

const Index = () => {
  const {coupons} = usePage().props;
  const {
    data,
    meta: {links}
  } = coupons;

  const {
    checked,
    checkboxesParent,
    handleCheck,
    handleCheckAll,
    parentCheckbox
  } = useCheckbox(data, 'id')



  return (
    <div>
      <div className='mb-3 flex justify-between items-center'>
        <h1 className="text-3xl font-bold">Added Coupons</h1>
        <InertiaLink
          className="btn-default focus:outline-none"
          href={route('added.coupons.create')}
        >
          <span>Create</span>
          <span className="hidden md:inline"> Coupon</span>
        </InertiaLink>
      </div>

      <div className="flex items-center justify-between mb-6">
        <AddedCouponsSearchFilter/>

        <PaginateCount/>
      </div>
      <div className="overflow-x-auto bg-white rounded shadow">
        <table className="w-full table-auto text-sm">
          <thead>
          <tr className="font-bold text-left">
            <th className="px-1 pt-5 pb-4 w-1">_</th>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-1' sortName='id' title='ID'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='code' title='Code'/>
            <th className="px-3 pt-5 pb-4 w-1.5"></th>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='description' title='Description'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='expire_date' title='Expiration'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='start_date' title='Date Entered'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='merchant_name' title='Merchant Name'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='ysnWorking' title='Working'/>
            <th className="px-1 pt-5 pb-4">Actions</th>
          </tr>
          </thead>
          <AddedCouponBottomPanel parentCheckbox={parentCheckbox} checked={checked} handleCheckAll={handleCheckAll}/>
          <tbody ref={checkboxesParent}>
          {data.map(({
                       id,
                       code,
                       description,
                       expire_date_iso,
                       start_date_iso,
                       merchant,
                       ysnWorking,
                       ysnSiteLink,
                       hot_coupon,
                       ysnTested,
                       isLive
                     }) => (
            <tr
              key={id}
              className="hover:bg-gray-100 focus-within:bg-gray-100"
            >
              <td className="border-t">
                <div className="flex items-center px-1 py-4 focus:text-indigo-700 focus:outline-none">
                  <input
                    type="checkbox"
                    name={id}
                    onChange={handleCheck} />
                </div>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="1"
                  className="flex items-center px-1 py-4 focus:text-indigo focus:outline-none"
                  href={route('added.coupons.edit', id)}
                >
                  {id}
                </InertiaLink>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('added.coupons.edit', id)}
                  className="flex items-center px-1 py-4 focus:text-indigo focus:outline-none"
                >
                  {code}
                </InertiaLink>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('added.coupons.edit', id)}
                  className="flex items-center px-1 py-4 focus:text-indigo focus:outline-none"
                >
                  {!!ysnSiteLink && <img className='h-6' src='/images/coupon/dollarsign.gif' alt='site link'/>}
                  {!!hot_coupon && <img className='h-4' src='/images/coupon/hotcouponstar.gif' alt='hot coupons'/>}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('added.coupons.edit', id)}
                  className="flex items-center px-1 focus:outline-none"
                >
                  {description}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('added.coupons.edit', id)}
                  className="flex items-center px-1 focus:outline-none"
                >
                  {expire_date_iso ? dayjs(expire_date_iso).format('MM-DD-YYYY HH:MM:ss') : 'Unknown'}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('added.coupons.edit', id)}
                  className="flex items-center px-1 focus:outline-none"
                >
                  {start_date_iso ? dayjs(start_date_iso).format('MM-DD-YYYY HH:MM:ss') : 'Unknown'}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('added.coupons.edit', id)}
                  className="flex items-center px-1 focus:outline-none"
                >
                  {merchant.merchant_name}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('added.coupons.edit', id)}
                  className="flex items-center px-1 focus:outline-none "
                >
                  {(isLive && !ysnTested) ? '-' : (!!ysnTested && !!ysnWorking) ? 'Yes' : 'No'}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <AddedCouponActionBtns isLive={isLive} id={id}/>
              </td>
            </tr>
          ))}
          {data.length === 0 && (
            <tr>
              <td className="px-1 py-4 border-t" colSpan="4">
                No coupons found.
              </td>
            </tr>
          )}
          </tbody>
        </table>
      </div>
      <Pagination links={links}/>
    </div>
  );
};


Index.layout = page => <Layout title="Added Coupons" children={page}/>;
export default Index;
